import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, initGA } from "../helpers/ga_helper";

/**
 * Google Analytics component that tracks page views on route changes
 * This component should be placed inside the Router component
 */
const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA on mount (only if not in dev)
    initGA();
  }, []);

  useEffect(() => {
    // Track page view when route changes
    const path = location.pathname + location.search;
    trackPageView(path, document.title);
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
